(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", 
    function(event) {
        
const mobileButton = document.querySelector('.mobile-menu__open');
const menu = document.querySelector('.menu');
const subMenusCtls = document.querySelectorAll('.menu__submenu-ctl');

const search = document.querySelector('.search-bar__form');
const openSearch = document.querySelector('.search-bar__open');
const closeSearch = document.querySelector('.search-bar__close');

openSearch.addEventListener('click', () =>{
  search.classList.remove('-translate-y-72'); 
  openSearch.classList.add('hidden');
  closeSearch.classList.remove('hidden');
  document.querySelector('.search__input').focus()
});
closeSearch.addEventListener('click', () =>{
  search.classList.add('-translate-y-72'); 
  closeSearch.classList.add('hidden');
  openSearch.classList.remove('hidden');
  document.querySelector('.search__input').blur()
});

mobileButton.addEventListener('click', () =>{
  closeSearch.click();
  menu.classList.toggle('translate-y-[100%]')
  menu.classList.toggle('opacity-0')
  mobileButton.children[0].classList.toggle('rotate-45');
  mobileButton.children[1].classList.toggle('scale-0');
  mobileButton.children[2].classList.toggle('-rotate-45');
});

subMenusCtls.forEach(elm => elm.addEventListener('click', (event) =>{
  if (window.matchMedia("(max-width: 1024px)").matches) {
    event.currentTarget.classList.toggle('rotate-180'); 
    console.log(event.currentTarget.parentElement.querySelector('.menu__submenu'))
    event.currentTarget.parentElement.querySelector('.menu__submenu').classList.toggle('hidden')
}
}));
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    

var patternFormDiv = document.querySelector('#pattern-download-form');
var patternForm = document.querySelector('#pattern_download');
var patternFormLeftSec = document.querySelector('.left-sec');
var patternFormLeftSecP = document.querySelector('.left-sec p');
var downloadLink = document.querySelector('#pattern-download-link');
var cookieRow = document.cookie.split('; ').find(row => row.startsWith('pattern_access'))
var currentURL = new URL(location.href);
if (currentURL.searchParams.has('customer_posted') || currentURL.searchParams.has('form_type') || cookieRow) {
    if(!cookieRow) {
        document.cookie = "pattern_access=true;";
    }
    patternFormDiv.classList.remove("lg:grid-cols-2");
    patternFormDiv.classList.remove("lg:text-left");
    patternForm.classList.add("hidden");
    patternForm.classList.add("lg:hidden");
    patternFormLeftSecP.classList.add("hidden");
    patternFormLeftSec.classList.add("lg:py-4");
    patternFormLeftSec.classList.remove("lg:py-20");
    downloadLink.classList.remove("hidden");
}

document.addEventListener("DOMContentLoaded", 
    function(event) {
        
        new Slider(document.querySelector('.grid-slider'), {
        slidesToShow: 4,
        slidesToScroll: 1
        });
    }
);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-signup"] && !Shopify.designMode) return;
  try {
    

var newsletterForm = document.querySelector('#contact_form');
var newsletterFormConfirm = document.querySelector('#contact_form_confirm');
var cookieRow = document.cookie.split('; ').find(row => row.startsWith('pattern_access'))
var currentURL = new URL(location.href);
console
if (currentURL.searchParams.has('customer_posted') || currentURL.searchParams.has('form_type')) {
    if(!cookieRow) {
        document.cookie = "pattern_access=true;";
    }
    newsletterFormConfirm.classList.remove("hidden");
    newsletterFormConfirm.classList.remove("lg:hidden");
    newsletterForm.classList.add("hidden");
    newsletterForm.classList.remove("lg:flex");
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["often-used-tools"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", 
    function(event) {
        
         new Slider(document.querySelector('.grid-slider'), {
        slidesToShow: 4,
        slidesToScroll: 1,
        });
    }
);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", 
    function(event) {
const leftArrow = document.querySelector('.left-arrow');

leftArrow.addEventListener('click', () => {
  var slides = document.querySelector('.slideshow');
  slides.appendChild(slides.childNodes[0]);
  slides.children[0].classList.remove('lg:col-start-3');
  slides.children[1].classList.add('lg:col-start-3');
  slides.children[1].classList.remove('lg:hidden');
  slides.children[slides.children.length - 1].classList.add('lg:hidden');
});

const rightArrow = document.querySelector('.right-arrow');

rightArrow.addEventListener('click', () => {
  var slides = document.querySelector('.slideshow');
  slides.insertBefore(slides.childNodes[slides.childNodes.length - 1], slides.childNodes[0]);
  slides.children[0].classList.remove('lg:hidden');
  slides.children[1].classList.add('lg:col-start-3');
  slides.children[2].classList.remove('lg:col-start-3');
  slides.children[2].classList.add('lg:hidden');
});
    }
);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", 
    function(event) {
        
        new Slider(document.querySelector('.grid-slider'), {
        slidesToShow: 4,
        slidesToScroll: 1
        });
    }
);

  } catch(e) { console.error(e); }
})();
})();
